import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import useAdminView from "../../../hooks/useAdminView";
import useBulkCsvUpload from "../../../hooks/useBulkCsvUpload";
import saveFile from "../../../utils/saveFile";
import servicesUtils from "../../../utils/servicesUtils";
import FileDropzone from "../../DicomUpload/FileDropzone";
import Toast from "../../Toast";
function UploadCsv(_ref) {
  var workspace = _ref.workspace;
  var _useAdminView = useAdminView(),
    _useAdminView2 = _slicedToArray(_useAdminView, 2),
    dispatch = _useAdminView2[1];
  var _useBulkCsvUpload = useBulkCsvUpload(),
    _useBulkCsvUpload2 = _slicedToArray(_useBulkCsvUpload, 2),
    csvUploadDispatch = _useBulkCsvUpload2[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "h-full flex flex-col p-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold space-y-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center space-x-3 text-gray-500"
  }, /*#__PURE__*/React.createElement("span", null, "Workspace:"), /*#__PURE__*/React.createElement("span", {
    className: "font-semibold text-gray-300"
  }, workspace === null || workspace === void 0 ? void 0 : workspace.label))), /*#__PURE__*/React.createElement("div", {
    className: "grow flex items-center justify-center"
  }, /*#__PURE__*/React.createElement(FileDropzone, {
    className: "",
    acceptedFiles: ".csv",
    onDropFiles: function onDropFiles(files) {
      try {
        var formData = new FormData();
        formData.append("file", files[0]);
        servicesUtils.postService("workspaces/".concat(workspace.value, "/site/users/create/"), formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }).then(function (res) {
          dispatch({
            type: "get-data"
          });
          csvUploadDispatch({
            type: "hide-modal"
          });
          Toast.success("CSV uploaded successfully");
        })["catch"](function (error) {
          Toast.error("Error while uploading CSV");
        });
      } catch (error) {
        Toast.error("Error while uploading CSV");
      }
    },
    isDropzoneDisabled: false,
    isHidden: false
  }, function (_ref2) {
    var open = _ref2.open;
    return /*#__PURE__*/React.createElement("div", {
      className: "py-6"
    }, /*#__PURE__*/React.createElement("p", {
      className: "my-2"
    }, "Drag and Drop here"), /*#__PURE__*/React.createElement("p", {
      className: "text-gray-600 text-md"
    }, "(Only .csv files are supported)"), /*#__PURE__*/React.createElement("span", {
      className: "flex justify-center text-gray-600 my-7"
    }, /*#__PURE__*/React.createElement("p", {
      className: "tracking-[3px]"
    }, "----------------"), /*#__PURE__*/React.createElement("p", {
      className: "mx-4 uppercase"
    }, "or"), /*#__PURE__*/React.createElement("p", {
      className: "tracking-[3px]"
    }, "----------------")), /*#__PURE__*/React.createElement("span", {
      className: "flex flex-col items-center"
    }, /*#__PURE__*/React.createElement("button", {
      className: "w-[156px] h-[48px] bg-teal-500 hover:bg-teal-600 text-base rounded-6",
      onClick: open
    }, "Upload CSV"), /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        fetch("/templates/BulkUserUpload.csv").then(function (res) {
          return res.blob();
        }).then(function (res) {
          saveFile(res, {
            fileName: "BulkUserUpload.csv",
            type: "text/csv;charset=utf-8;"
          });
        });
      },
      className: "text-[12px] mt-3 text-gray-400 underline hover:text-gray-100"
    }, "Download CSV template")));
  })));
}
export default UploadCsv;